export * from './dependants.component';